import { render, staticRenderFns } from "./CountryList.vue?vue&type=template&id=5f783e00&scoped=true&"
import script from "./CountryList.vue?vue&type=script&lang=js&"
export * from "./CountryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f783e00",
  null
  
)

export default component.exports